import RemoveChatsModal from "./RemoveChatsModal";
export default RemoveChatsModal;
